import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '/src/app';
import { sentryInit } from '/src/services';

sentryInit();

ReactDOM
    .createRoot(document.getElementById('root'))
    .render(
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );

if ('serviceWorker' in navigator) {
    const JS_VERSION = process.env.SERVICE_WORKER_VERSION;

    const showUpdateDialog = () => {
        const updateDialogId = 'need-update';
        const dialog = document.getElementById(updateDialogId) || document.createElement('div');
        dialog.id = updateDialogId;
        dialog.style.position = 'fixed';
        dialog.style.bottom = '0';
        dialog.style.left = '0';
        dialog.style.right = '0';
        dialog.style.top = '0';
        dialog.style.display = 'flex';
        dialog.style.flexDirection = 'column';
        dialog.style.justifyContent = 'center';
        dialog.style.alignItems = 'center';
        dialog.style.zIndex = '9999';
        dialog.innerHTML = `
            <div style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; background-color: black; opacity: 0.3; z-index: 0"></div>
            <div style="z-index: 2; display: flex; flex-direction: column; align-items: center; background-color: white; padding: 24px 32px; border-radius: 8px; box-shadow: 0 0 10px rgba(0,0,0,0.2) ">
                <p style="margin: 0 0 30px; font-size: 18px; color: #3E403A; font-weight: 700">
                    We just updated our site. Please refresh the page to get the latest version. You will not be able to use the site until you refresh.
                </p>
                <button
                    style="padding: 12px 24px; background-color: #889C51; box-shadow: 0 1px 3px 1px rgba(155, 155, 155, 0.7); border: 2px solid rgb(255, 255, 255); color: white; border-radius: 4px; font-size: 16px; cursor: pointer"
                    onclick="window.location.reload()"
                >
                    Refresh the page
                </button>
            </div>
        `;

        document.body.appendChild(dialog);
    };

    const checkServiceWorkerVersion = () => {
        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({ type: 'GET_VERSION' });
        }
    };

    const updateEvent = () => {
        navigator.serviceWorker.getRegistration().then(reg => {
            if (reg) {
                reg.update();
            }
        });
        checkServiceWorkerVersion();
    };

    navigator.serviceWorker.register('/service-worker.js').catch(error => console.log(error));

    document.getElementById('root').addEventListener('click', updateEvent);

    navigator.serviceWorker.addEventListener('message', event => {
        if (event.data?.type === 'CURRENT_VERSION' || event.data?.type === 'NEW_VERSION_AVAILABLE') {
            if (JS_VERSION !== event.data.version) {
                showUpdateDialog();
            }
        }
    });
}
